$(function(){
  updateSwiper();
  $(window).resize(function(){
    updateSwiper();
  });
  setTimeout(function(){
    updateSwiper();
  }, 1000)
  $(".custom-cl-tab").click(function(){
    let id = $(this).attr("data-id");
    $(this).parents(".custom-cl").find(".custom-cl-tab").removeClass("active");
    $(this).addClass("active");
    $(this).parents(".custom-cl").find(".custom-cl-swiper-container").hide();
    $(this).parents(".custom-cl").find(`.custom-cl-swiper-container[data-id="${id}"]`).fadeIn(300);
  })
  $(".custom-faq-title").click(function(){
    $(this).toggleClass("active");
    $(this).next(".custom-faq-text").slideToggle(300);
  })
  $(".custom-pdp-accordion-heading").click(function(){
    $(this).toggleClass("active");
    $(this).next(".custom-pdp-accordion-content").slideToggle(300);
  })
  $(".custom-footer-title").click(function(){
    $(this).toggleClass("active");
    $(this).next(".custom-footer-content").slideToggle(300);
  })
  // $(".custom-search-toggle-mobile").click(function(e){
  //   e.stopPropagation();
  //   document.querySelector(".header__search summary").dispatchEvent(new Event('click'), {bubbles: true})
  // })
  $(".facets__heading").click(function(){
    $(this).toggleClass("active");
    $("#FacetsWrapperDesktop").slideToggle();
  })
  $(document).on("click", ".custom-card-btn", function(){
    let arr = [];
    arr.push({ 'id': $(this).attr("data-id"), 'quantity': 1 });
    AddProductsToCart(arr, $(this));
  })
  $(document).on("click", ".custom-cart-rec-btn", function(){
    let arr = [];
    arr.push({ 'id': $(this).attr("data-id"), 'quantity': 1 });
    AddProductsToCart(arr, $(this), false);
  })
})

function updateSwiper(){
  if($(".custom-cl-swiper").length > 0){
    if($(window).width() <= 749){
      $(".custom-cl-swiper").attr("slides-per-view", "2");
      $(".custom-cl-swiper").attr("slides-per-group", "2");
    }
    else if($(window).width() <= 989){
      $(".custom-cl-swiper").attr("slides-per-view", "3");
      $(".custom-cl-swiper").attr("slides-per-group", "3");
    }
    else if($(window).width() <= 1049){
      $(".custom-cl-swiper").attr("slides-per-view", "3");
      $(".custom-cl-swiper").attr("slides-per-group", "3");
    }
    else{
      $(".custom-cl-swiper").attr("slides-per-view", "4");
      $(".custom-cl-swiper").attr("slides-per-group", "4");
    }
  }
}

function AddProductsToCart(productsArr, $this, openCart=true){
  $this.addClass("active");
  let formData = {
    'items': productsArr,
    sections: "cart-drawer,cart-icon-bubble"
  };
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'xmlhttprequest'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
    return response.json();
  })
  .then(res => {
    console.log("response", res);
    if(res.status){
      console.log(res);
    }
    else{
      const cartParsedData = new DOMParser().parseFromString(res.sections['cart-drawer'], 'text/html');
      const cartBubbleParsedData = new DOMParser().parseFromString(res.sections['cart-icon-bubble'], 'text/html');
      $("cart-drawer.drawer").removeClass("is-empty");
      $(".drawer__inner").html($(cartParsedData).find(".drawer__inner").html());
      $("#cart-icon-bubble").html($(cartBubbleParsedData).find(".shopify-section").html());
      if(openCart){
        $(".cart-count-bubble").trigger("click");
      }
    }
  })
  .catch((error) => {
    console.error('Error:', error);
  })
  .finally(() => {
    $this.removeClass("active");
  });
}

$(".custom-mobile-menu-toggle").click(function(e){
  e.preventDefault();
  $(this).toggleClass("active");
  $(this).next(".custom-mobile-menu-ul").slideToggle(300);
})

$(document).on('click', '.custom-card-btn', function(e) {
    e.preventDefault();
    e.stopImmediatePropagation(); 

    var url = $(this).data('url');
    if (url) {
        window.location.href = url;
    }
});
